module.exports = __webpack_public_path__ + "static/media/cross.507adf3a.svg";